export function useFileUpload() {
  function filesAreOfAcceptableType(
    fileList: FileList,
    availableTypes: string[]
  ) {
    for (const file of Array.from(fileList)) {
      if (!availableTypes.includes(file.type)) {
        return false
      }
    }
    return true
  }
  return {
    filesAreOfAcceptableType
  }
}
